<template>
	<sa-page-layout :btnSaveVisible="btnSaveVisible" :btnAnnullaVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
		<template slot="table-body">
			<gestione-attivita-progetti-edit-component ref="cmpGestioneAttivitaProgettiEditComponent" @updateJsonData="onUpdateJsonData"></gestione-attivita-progetti-edit-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaProgettiEditComponent from "../components/GestioneAttivitaProgettiEditComponent.vue";
export default {
	components: { GestioneAttivitaProgettiEditComponent, SaPageLayout },
	data() {
		return {
			btnSaveVisible: true,
			showModalLoading: false,
			linkback: "/gestioneattivita/progetti",
			pathResource: "/gestioneattivitaprogetti",
			jsonData: null,
		};
	},
	mounted() {
		this.$refs.cmpGestioneAttivitaProgettiEditComponent.init("PROGETTO");
	},
	methods: {
		onUpdateJsonData(jsonData) {
			this.jsonData = jsonData;
		},
	},
};
</script>

<style></style>
